import { useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import PaperPlaneIcon from '@nv/images/design/paper-plane-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './EmailSent.module.scss'
import '@djthoms/pretty-checkbox'

export const EmailSent = ({ formik, isAdminRequest }: any) => {
  const { t } = useTranslation()
  const location = useLocation()
  const pathname = location.pathname
  const navigate = useNavigate()
  const [isResetCodeClicked, setIsResetCodeClicked] = useState(false)
  const [isResetCodeSuccess, setIsResetCodeSuccess] = useState(null)

  const resendCode = async () => {
    setIsResetCodeClicked(true)
    try {
      await formik.submitForm()
      setIsResetCodeSuccess(true)
    } catch {
      setIsResetCodeSuccess(false)
    }
  }

  return (
    <div className={styles['container']}>
      <div className={styles['container__inner']}>
        <div className={styles['body']}>
          <PaperPlaneIcon className={styles['plane-icon']} />

          <h1 className={styles['title']}>{t('form.messages.resetPwSubmitted')}</h1>

          <span className={styles['subtitle']}>
            {isAdminRequest ? t('form.messages.requestResetPwMade') : t('form.messages.ifInfoCorrectTempPwSent')}
          </span>
          {!isAdminRequest && (
            <span className={styles['info']}>
              <>
                {isResetCodeClicked ? (
                  isResetCodeSuccess === null ? (
                    t('main.sending')
                  ) : isResetCodeSuccess ? (
                    <>
                      {t('events.voteVerification.sendCodeSuccess')}
                      <span className={styles['svg']}>
                        <CheckAnimationIcon />
                      </span>
                    </>
                  ) : (
                    <>
                      {t('events.voteVerification.sendCodeError')}
                      <span className={styles['svg']}>
                        <XCircleAnimatedIcon />
                      </span>
                    </>
                  )
                ) : (
                  <>
                    {t('form.messages.didntGetIt')}
                    <NVButton variant='text' onClick={() => resendCode()} text={t('auth.login.validations.sendAgain')} />
                  </>
                )}
              </>
            </span>
          )}
        </div>

        <div className={styles['footer']}>
          <NVButton
            text={t('buttons.next')}
            classes={{ container: styles['footer__btn'] }}
            onClick={() => (pathname.includes('admin') ? navigate('/admin/login') : navigate('/voting/voter-login/'))}
          />
        </div>
      </div>
    </div>
  )
}
